import { useQuery } from '@tanstack/react-query';
import { getLatestProducts } from '../../../services/monitor/features/MonitorFeaturesService';
import { LatestProductsResponse } from '../../../../models/monitor/ResponseFeatures';

export const GET_LATEST_PRODUCTS = 'get-latest-products';

export interface LatestProductsParams {
  monitorId: number;
  from: Date | null;
  to: Date | null;
  models?: string[];
  limit?: number;
}

export const useGetLatestProducts = (params: LatestProductsParams | null) => {
  const fromTimestamp = params?.from?.getTime() ?? null;
  const toTimestamp = params?.to?.getTime() ?? null;

  const query = useQuery<LatestProductsResponse>({
    queryKey: [
      GET_LATEST_PRODUCTS,
      params?.monitorId,
      fromTimestamp,
      toTimestamp,
      params?.models,
      params?.limit,
    ],
    queryFn: () => {
      if (!params || !params.from || !params.to) {
        throw new Error('Params with dates are required');
      }
      return getLatestProducts(params.monitorId, params.from, params.to, params.models, params.limit);
    },
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    enabled: !!params && !!params.from && !!params.to && !!params.monitorId,
  });

  return {
    latestProducts: query.data?.items ?? null,
    isLoading: query.isLoading,
  };
};
